import {
  FETCH_TITLES,
  FETCH_TITLES_SUCCESS,
  FETCH_TITLES_FAILURE,
  FETCH_ADDRESS_PROJECT,
  FETCH_ADDRESS_PROJECT_SUCCESS,
  FETCH_ADDRESS_PROJECT_FAILURE,
  FETCH_PROJECT_COMPANY,
  FETCH_PROJECT_COMPANY_SUCCESS,
  FETCH_PROJECT_COMPANY_FAILURE,
} from "./queryAction";

const initialState = {
  items: [],
  delivery: [],
  company: [],
  isFetching: false
};

export default function(state = initialState, action) {
  switch (action.type) {
    case FETCH_TITLES:
      return {
        ...state,
        items: [],
        isFetching: true
      };
    case FETCH_TITLES_SUCCESS:
      return {
        ...state,
        items: action.payload,
        isFetching: false
      };
    case FETCH_TITLES_FAILURE:
      return {
        ...state,
        items: [],
        isFetching: false
      };
    case FETCH_ADDRESS_PROJECT:
      return {
        ...state,
        delivery: [],
        isFetching: true
      };
    case FETCH_ADDRESS_PROJECT_SUCCESS:
      return {
        ...state,
        delivery: action.payload,
        isFetching: false
      };
    case FETCH_ADDRESS_PROJECT_FAILURE:
      return {
        ...state,
        delivery: [],
        isFetching: false
      };
    case FETCH_PROJECT_COMPANY:
      return {
        ...state,
        company: [],
        isFetching: true
      };
    case FETCH_PROJECT_COMPANY_SUCCESS:
      return {
        ...state,
        company: action.payload,
        isFetching: false
      };
    case FETCH_PROJECT_COMPANY_FAILURE:
      return {
        ...state,
        company: [],
        isFetching: false
      };
    default:
      return state;
  }
}
